module.exports = __webpack_public_path__ + "img/jason_mcCourty.d51d1892.png";